import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const HeaderLogo = ({ bgStyle }) => {
    let brandFillClass;
    let fillClass;

    switch(bgStyle) {
        case 'transparent':
            brandFillClass = 'text-white';
            fillClass = 'text-white';
            break;

        case 'transparent-landing':
            brandFillClass = 'text-core-brand';
            fillClass = 'text-white';
            break;

        case 'white':
            brandFillClass = 'text-grey-black';
            fillClass = 'text-core-brand';
            break;

        case 'black':
            brandFillClass = 'text-black';
            fillClass = 'text-black';
            break;

        default:
            brandFillClass = 'text-core-brand';
            fillClass = 'text-white';
    }

    return (
        <svg
            className={fillClass}
            fill='none'
            height='13'
            viewBox='0 0 153 13'
            width='153'
            xmlns='http://www.w3.org/2000/svg'>
            <title>Strava Business</title>
            <path
                className={brandFillClass}
                d='M148.315 12.7648C145.745 12.7648 143.982 11.8243 143.646 10.3798L146.199 9.87594C146.451 10.6485 147.307 11.0517 148.416 11.0517C149.642 11.0517 150.264 10.6318 150.264 9.97672C150.264 9.47284 149.894 9.20411 149.071 9.13692L146.988 8.96896C144.939 8.8178 143.965 7.84364 143.965 6.53356C143.965 4.80359 145.645 3.61108 148.366 3.61108C150.751 3.61108 152.363 4.45088 152.817 5.87853L150.331 6.43279C150.045 5.66018 149.34 5.32426 148.282 5.32426C147.156 5.32426 146.552 5.74416 146.552 6.31522C146.552 6.7855 146.938 7.03744 147.744 7.10462L149.978 7.30617C151.977 7.45734 152.85 8.4147 152.85 9.74157C152.85 11.5555 151.12 12.7648 148.315 12.7648Z'
                fill='currentColor'/>
            <path
                className={brandFillClass}
                d='M137.802 12.7648C135.232 12.7648 133.468 11.8243 133.132 10.3798L135.685 9.87594C135.937 10.6485 136.794 11.0517 137.902 11.0517C139.128 11.0517 139.75 10.6318 139.75 9.97672C139.75 9.47284 139.38 9.20411 138.557 9.13692L136.475 8.96896C134.426 8.8178 133.451 7.84364 133.451 6.53356C133.451 4.80359 135.131 3.61108 137.852 3.61108C140.237 3.61108 141.849 4.45088 142.303 5.87853L139.817 6.43279C139.532 5.66018 138.826 5.32426 137.768 5.32426C136.643 5.32426 136.038 5.74416 136.038 6.31522C136.038 6.7855 136.424 7.03744 137.231 7.10462L139.464 7.30617C141.463 7.45734 142.336 8.4147 142.336 9.74157C142.336 11.5555 140.606 12.7648 137.802 12.7648Z'
                fill='currentColor'/>
            <path
                className={brandFillClass}
                d='M127.003 12.7648C123.846 12.7648 121.864 11.0013 121.864 8.17956C121.864 5.40824 123.846 3.61108 126.919 3.61108C129.926 3.61108 131.908 5.25708 131.908 7.81005C131.908 8.21315 131.857 8.56586 131.807 8.85139L124.417 8.85139C124.434 10.1279 125.458 10.9677 127.07 10.9677C127.977 10.9677 128.817 10.6653 129.237 9.84235L131.706 10.4638C131.018 11.925 129.355 12.7648 127.003 12.7648ZM124.417 7.33977L129.304 7.33977C129.271 5.9625 128.313 5.30747 126.919 5.30747C125.458 5.30747 124.484 6.11367 124.417 7.33977Z'
                fill='currentColor'/>
            <path
                className={brandFillClass}
                d='M110.853 12.5129V3.86302L113.255 3.86302V5.05553H113.322C114.112 4.08137 115.22 3.61108 116.614 3.61108C118.747 3.61108 120.158 4.87077 120.158 7.37336V12.5129H117.656V7.81005C117.656 6.36561 116.95 5.60979 115.674 5.60979C114.498 5.60979 113.742 6.28163 113.356 6.8023V12.5129H110.853Z'
                fill='currentColor'/>
            <path
                className={brandFillClass}
                d='M106.129 12.5129V3.86305L108.632 3.86305V12.5129H106.129ZM107.389 2.65375C106.516 2.65375 105.945 2.09948 105.945 1.32687C105.945 0.57106 106.516 0 107.389 0C108.229 0 108.817 0.57106 108.817 1.32687C108.817 2.09948 108.229 2.65375 107.389 2.65375Z'
                fill='currentColor'/>
            <path
                className={brandFillClass}
                d='M99.7811 12.7648C97.2113 12.7648 95.4477 11.8243 95.1118 10.3798L97.6648 9.87594C97.9167 10.6485 98.7733 11.0517 99.8818 11.0517C101.108 11.0517 101.729 10.6318 101.729 9.97672C101.729 9.47284 101.36 9.20411 100.537 9.13692L98.4542 8.96896C96.4051 8.8178 95.4309 7.84364 95.4309 6.53356C95.4309 4.80359 97.1105 3.61108 99.8315 3.61108C102.216 3.61108 103.829 4.45088 104.282 5.87853L101.797 6.43279C101.511 5.66018 100.806 5.32426 99.7475 5.32426C98.6222 5.32426 98.0175 5.74416 98.0175 6.31522C98.0175 6.7855 98.4038 7.03744 99.21 7.10462L101.444 7.30617C103.443 7.45734 104.316 8.4147 104.316 9.74157C104.316 11.5555 102.586 12.7648 99.7811 12.7648Z'
                fill='currentColor'/>
            <path
                className={brandFillClass}
                d='M93.3979 3.86307V12.5129H90.9961V11.3204H90.929C90.1563 12.2946 89.0814 12.7649 87.7713 12.7649C85.6886 12.7649 84.345 11.5052 84.345 9.0026V3.86307L86.8476 3.86307V8.56591C86.8476 10.0104 87.4858 10.7662 88.6951 10.7662C89.8204 10.7662 90.509 10.0943 90.8954 9.57366V3.86307L93.3979 3.86307Z'
                fill='currentColor'/>
            <path
                className={brandFillClass}
                d='M71.3633 12.5129V0.671844L78.4007 0.671844C80.9201 0.671844 82.247 1.91474 82.247 3.71189C82.247 5.02197 81.4576 5.92895 80.03 6.28166V6.36564C81.6256 6.66797 82.5661 7.7429 82.5661 9.25453C82.5661 11.1189 81.2057 12.5129 78.6359 12.5129L71.3633 12.5129ZM78.1488 10.5478C79.2237 10.5478 79.8284 9.95996 79.8284 8.969C79.8284 7.96125 79.207 7.37339 78.1152 7.37339L73.9834 7.37339V10.5478L78.1488 10.5478ZM73.9834 5.50905L77.8801 5.50905C78.9382 5.50905 79.5093 4.9044 79.5093 4.04781C79.5093 3.19122 78.955 2.63696 77.9305 2.63696L73.9834 2.63696V5.50905Z'
                fill='currentColor'/>
            <path
                d='M23.9005 12.5129L23.9005 0.671814L29.7119 0.671814C31.845 0.671814 33.1886 1.20928 34.0284 2.01548C34.7338 2.7377 35.1034 3.61109 35.1034 4.83719V4.87078C35.1034 6.60075 34.2132 7.79326 32.7687 8.49868L35.1034 11.8914L41.217 0.167938L47.6667 12.5129H43.3837L41.217 8.19636L39.0504 12.5129L35.54 12.5129H30.9716L28.7377 9.13693H27.8811L27.8811 12.5129L23.9005 12.5129ZM6.11369 12.7312C3.71189 12.7312 1.51163 12.0594 0 10.7325L2.13307 8.21315C3.42636 9.20411 4.92119 9.60721 6.31524 9.60721C7.02067 9.60721 7.33979 9.40566 7.33979 9.10334V9.06974C7.33979 8.71703 6.95349 8.54907 5.677 8.28034C3.00646 7.74287 0.655039 6.98706 0.655039 4.48447V4.45088C0.655039 2.20024 2.4354 0.453467 5.71059 0.453467C8.02842 0.453467 9.7248 0.990935 11.1021 2.06587L9.17054 4.75321C8.04522 3.93021 6.70155 3.5775 5.57623 3.5775C4.98837 3.5775 4.70284 3.77905 4.70284 4.06458V4.09817C4.70284 4.43409 5.03876 4.61884 6.29845 4.87078C9.35529 5.42504 11.4044 6.31522 11.4044 8.68344V8.71703C11.4044 11.2196 9.3385 12.7312 6.11369 12.7312ZM15.3682 12.5129L15.3682 4.01419L11.8579 4.01419V0.671814L22.8592 0.671814V4.01419H19.3656L19.3656 12.5129L15.3682 12.5129ZM29.5943 6.31522C30.5685 6.31522 31.1395 5.89533 31.1395 5.15631V5.12272C31.1395 4.3669 30.5517 3.9806 29.6111 3.9806L27.8811 3.9806V6.31522H29.5943ZM50.6731 13L44.2403 0.655018L48.5064 0.655018L50.6731 4.97155L52.8398 0.655018L57.1227 0.655018L50.6731 13ZM53.6964 12.5129L60.1292 0.167938L66.5788 12.5129H62.2959L60.1292 8.19636L57.9625 12.5129H53.6964Z'
                fill='currentColor'/>

        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    bgStyle: PropTypes.oneOf(['transparent', 'transparent-landing', 'white', 'black']).isRequired,
};

HeaderLogo.propTypes = propTypes;

export default HeaderLogo;
